import React from 'react';
import '../App.css';

export function NoMatchView() {
    return (
        <div>
            <h2>Nothing to see here!</h2>
            <p>
                <a href="/">Go to the home page</a>
            </p>
        </div>
    );
}

